<script>
//import Switcher from "@/components/switcher";

/**
 * Page-thankyou component
 */
export default {
  data() {
    return {};
  },
};
</script>
<template>
  <div>
    <!-- Hero Start -->
    <section class="bg-home bg-light d-flex align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-12">
            <div class="text-center">
              <div
                class="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                style="height: 90px; width: 90px"
              >
                <i class="uil uil-thumbs-up align-middle h1 mb-0"></i>
              </div>
              <h1 class="my-4 font-weight-bold">¡Gracias por tu registro!</h1>
              <p class="text-muted para-desc mx-auto">
                En algunos minutos recibirás un correo eléctronico con las instrucciones para continuar con tu proceso de segunda opinión.
              </p>
              <div class="alert alert-warning mt-3" role="alert">
                 <span class="alert-content"> No olvides revisar tu bandeja de correo no deseado. <br/> En caso de de ser así te recomendamos marcarlo como "No Spam" para mejorar la comunicación con nuestro equipo. </span>
              </div>
              <router-link to="/" class="btn btn-soft-primary mt-3"
                >Ir a Inicio</router-link
              >
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
    <!--Switcher /-->
  </div>
</template>